<template>
  <div v-if="!mediaExpired"
       class="checkin__last-call w-100 d-flex align-items-center justify-content-between">
    <div class="checkin__last-call__message">
      <Icon name="alertTriangle" width="20" class="checkin__last-call__icon"/>
      <span class="checkin__last-call__text">{{ $t('pages.checkins.media_deleting') }}</span>
    </div>
    <b-button size="sm" class="checkin__last-call__cta text-nowrap" variant="outline">
      {{ $t('pages.checkins.media_deleting_btn') }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "InfoMediaAvailableList",
  props: {
    availableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    mediaExpired() {
      return new Date(this.availableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>